import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

const AGENTS = {
  ifw_book_appointment: {
    id: "agent_3ae7a17650786e82c62d634187",
    label: "IFW Jennifer Appointment Booking",
    enabled: true,
    fields: ["email", "state"],
  },
  ifw_confirm_appointment: {
    id: "agent_8adca52d378ae839c45a1fada0",
    label: "IFW Jennifer Appointment Confirmation",
    enabled: true,
    fields: ["appointment"],
  },
  ifw_final_expense_lt: {
    id: "agent_0c3555c0a7458be2a099752e8f",
    label: "IFW Final Expense FB LT - Senior Solutions",
    enabled: true,
    fields: ["state"],
  },
};

export const IFWAnnuitiesDemo = () => {
  const [country, setCountry] = useState("ca");
  const [selectedAgent, setSelectedAgent] = useState("ifw_book_appointment");
  const [testV2FirstName, setTestV2FirstName] = useState("");
  const [testV2PhoneNumber, setTestV2PhoneNumber] = useState("");
  const [testV2Email, setTestV2Email] = useState("");
  const [testV2LastName, setTestV2LastName] = useState("");
  const [testV2State, setTestV2State] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [appointmentDatetime, setAppointmentDatetime] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    // const human_agent_first_name = "Marco";
    // const fromNumber = "12392081459";
    // const fromNumber = "15489185087";
    const fromNumber = "12392081459";
    const baseUrl = "https://initiate-retell-call-7blmr5azyq-uc.a.run.app";
    const agentConfig = AGENTS[selectedAgent];
    let agent_id = agentConfig.id;
    let lead_first_name = testV2FirstName;
    let lead_type = selectedAgent;
    let to_number = testV2PhoneNumber;
    let lead_email = testV2Email;
    let lead_full_name = `${testV2FirstName} ${testV2LastName}`;
    let human_agent_id = "0ho90QkFDmsLuKGZ4iAv";
    let lead_id = "FSHpnvJoxO7iFKP63BxF";
    let agency_id = "CY86eQwNdG3WpMJqVj2X";
    let insurscale_agency_id = "CY86eQwNdG3WpMJqVj2X";

    let human_agent_company_name = "Institute of Financial Wellness";

    let lead_last_name = testV2LastName;
    let apiUrl = `${baseUrl}?lead_full_name=${lead_full_name}&lead_first_name=${lead_first_name}&lead_last_name=${lead_last_name}&from_number=${fromNumber}&agent_id=${agent_id}&to_number=+${to_number}&lead_id=${lead_id}&lead_type=${lead_type}&human_agent_id=${human_agent_id}&human_agent_company_name=${human_agent_company_name}&agency_id=${agency_id}&insurscale_agency_id=${insurscale_agency_id}`;

    // Add email if the agent requires it
    if (agentConfig.fields?.includes("email") && lead_email) {
      apiUrl += `&lead_email=${lead_email}`;
    }

    // Add lead_state if the agent requires it
    if (agentConfig.fields?.includes("state") && testV2State) {
      apiUrl += `&lead_state=${testV2State}`;
    }

    // Add booking_id and appointment_datetime if the agent requires appointment fields
    if (agentConfig.fields?.includes("appointment")) {
      if (appointmentId) {
        apiUrl += `&booking_id=${appointmentId}`;
      }
      if (appointmentDatetime) {
        // Convert datetime-local value to ISO format
        const isoDatetime = new Date(appointmentDatetime).toISOString();
        apiUrl += `&appointment_datetime=${encodeURIComponent(isoDatetime)}`;
      }
    }

    await axios
      .request(apiUrl, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => window.alert("Call initiated successfully!"));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: "center", marginBottom: "1rem" }}>
            <h1
              style={{
                color: "#FFFFFF",
                fontSize: "2rem",
                fontWeight: "bold",
                margin: "1rem",
              }}
            >
              IFW DEMOs
            </h1>
            <div
              style={{
                height: "4px",
                width: "100px",
                background: "linear-gradient(90deg, #a0b8ff, #8a2be2)",
                margin: "0 auto",
                borderRadius: "2px",
              }}
            ></div>
          </div>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <h3
                style={{
                  color: "#FFFFFF",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  margin: "0",
                  textAlign: "left",
                }}
              >
                Select Agent
              </h3>
              <FormControl fullWidth>
                <Select
                  value={selectedAgent}
                  onChange={(e) => {
                    setSelectedAgent(e.target.value);
                    // Clear appointment fields when switching to an agent without appointment fields
                    if (
                      !AGENTS[e.target.value]?.fields?.includes("appointment")
                    ) {
                      setAppointmentId("");
                      setAppointmentDatetime("");
                    }
                  }}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    height: "56px",
                    textAlign: "left",
                    "& .MuiSelect-select": {
                      textAlign: "left",
                    },
                  }}
                >
                  {Object.entries(AGENTS)
                    .filter(([key, agent]) => agent.enabled)
                    .map(([key, agent]) => (
                      <MenuItem key={key} value={key}>
                        {agent.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <TextField
                  autoFocus
                  label="First Name"
                  variant="filled"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={testV2FirstName}
                  onChange={(e) => setTestV2FirstName(e.target.value)}
                  required
                />
                <TextField
                  label="Last Name"
                  variant="filled"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={testV2LastName}
                  onChange={(e) => setTestV2LastName(e.target.value)}
                  required
                />
              </Stack>
              {AGENTS[selectedAgent]?.fields?.includes("email") && (
                <TextField
                  label="Email"
                  variant="filled"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={testV2Email}
                  onChange={(e) => setTestV2Email(e.target.value)}
                  required
                />
              )}
              {AGENTS[selectedAgent]?.fields?.includes("state") && (
                <TextField
                  label="State"
                  variant="filled"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={testV2State}
                  onChange={(e) => setTestV2State(e.target.value)}
                  required
                />
              )}
              {AGENTS[selectedAgent]?.fields?.includes("appointment") && (
                <>
                  <TextField
                    label="Booking ID"
                    variant="filled"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    value={appointmentId}
                    onChange={(e) => setAppointmentId(e.target.value)}
                    required
                  />
                  <TextField
                    label="Appointment Date & Time"
                    type="datetime-local"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    value={appointmentDatetime}
                    onChange={(e) => setAppointmentDatetime(e.target.value)}
                    required
                  />
                </>
              )}
              <h3
                style={{
                  color: "#FFFFFF",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  margin: "16px 0 0 0",
                  textAlign: "left",
                }}
              >
                Your Number
              </h3>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
              >
                <FormControl sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                      height: "56px",
                    }}
                    required
                  >
                    <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                    <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ flex: { sm: "1" }, width: "100%" }}>
                  <PhoneInput
                    country={country}
                    value={testV2PhoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setTestV2PhoneNumber}
                    enableLongNumbers={true}
                    placeholder="Enter your phone number"
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    required
                  />
                </Box>
              </Stack>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background:
                    "linear-gradient(45deg, #1976d2 30%, #2196f3 90%)",
                  boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
                  color: "white",
                  height: "56px",
                  padding: "0 30px",
                  transition:
                    "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 10px 4px rgba(33, 203, 243, .3)",
                    background:
                      "linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)",
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Click here to receive the DEMO call
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              <div
                style={{
                  backgroundColor: "#eaf2fa",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #d0e0f0",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span style={{ fontSize: "24px" }}>ℹ️</span>
                <p
                  style={{
                    margin: 0,
                    textAlign: "left",
                    color: "#333",
                    lineHeight: "1.5",
                    fontSize: "14px",
                  }}
                >
                  After clicking to receive the DEMO call, you will receive a
                  call from the following number:
                  <b style={{ color: "#005a9c" }}> +1 (239) 208-1459</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
